import React from 'react';

import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';

import { Button, Card, Typography } from '../../atoms';

const useStyles = makeStyles((theme: Theme) => ({
  actionText: {
    fontSize: theme.typography.pxToRem(14),
  },
  bottomSection: {
    justifyContent: 'space-between',
    display: 'flex',
    flexDirection: 'row',
    marginTop: 'auto',
  },
  button: {
    marginLeft: theme.spacing(1),
    '&.MuiButton-outlined': {
      padding: theme.spacing(1, 1.5),
    },
    '& p': {
      textAlign: 'center',
    },
  },
  description: {
    display: '-webkit-box',
    fontSize: theme.typography.pxToRem(13),
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    '-webkit-line-clamp': 2,
    '-webkit-box-orient': 'vertical',
  },
  price: {
    marginTop: 'auto',
  },
  root: {
    background: theme.palette.common.white,
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    padding: theme.spacing(1.5),
  },
  title: {
    marginBottom: theme.spacing(0.25),
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    width: 256,
  },
  topSection: {
    display: 'flex',
    flexDirection: 'column',
  },
}));

export type Props = {
  action: () => void;
  actionText: string;
  description: string;
  price: string;
  title?: string;
};

export function ReorderCard(props: Props): JSX.Element {
  const { action, actionText, description, price, title } = props;
  const classes = useStyles();
  const rootStyle = clsx('fd-reorder-card', classes.root);

  return (
    <Card className={rootStyle}>
      <div className={classes.topSection}>
        {title && (
          <Typography
            className={classes.title}
            data-fd="reorder-title"
            variant="caption"
          >
            {title}
          </Typography>
        )}
        <Typography className={classes.description}>{description}</Typography>
      </div>

      <div className={classes.bottomSection}>
        <Typography className={classes.price} variant="caption">
          {price}
        </Typography>
        <Button className={classes.button} onClick={action} variant="secondary">
          <Typography className={classes.actionText}>{actionText}</Typography>
        </Button>
      </div>
    </Card>
  );
}
